import { memo } from 'react';
import { useTheme } from '@/theme/themeContext';

interface Props {
  path: string;
}

export const ConnectorRenderer = memo(function ConnectorRenderer({ path }: Props) {
  const theme = useTheme();

  return (
    <path
      d={path}
      fill="none"
      stroke={theme.connectorStyle.color}
      strokeWidth={theme.connectorStyle.width}
      strokeLinecap="round"
    />
  );
});
